import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/home.css';

// As 12 portas do zodíaco (marcação exata da proposta; clicar leva à
// conversa com o signo no contexto — honesto: hover = clique funciona)
const SIGNS = [
  { glyph: '♈', name: 'Áries', traits: 'Pioneirismo · Coragem' },
  { glyph: '♉', name: 'Touro', traits: 'Firmeza · Prazer' },
  { glyph: '♊', name: 'Gêmeos', traits: 'Curiosidade · Palavra' },
  { glyph: '♋', name: 'Câncer', traits: 'Memória · Cuidado' },
  { glyph: '♌', name: 'Leão', traits: 'Vitalidade · Brilho' },
  { glyph: '♍', name: 'Virgem', traits: 'Ofício · Precisão' },
  { glyph: '♎', name: 'Libra', traits: 'Gozo · Equilíbrio' },
  { glyph: '♏', name: 'Escorpião', traits: 'Intensidade · Mistério' },
  { glyph: '♐', name: 'Sagitário', traits: 'Expansão · Sentido' },
  { glyph: '♑', name: 'Capricórnio', traits: 'Montanha · Tempo' },
  { glyph: '♒', name: 'Aquário', traits: 'Arrojo · Comunidade' },
  { glyph: '♓', name: 'Peixes', traits: 'Empatia · Sonho' },
];

export const SignsGrid: React.FC = () => {
  const navigate = useNavigate();
  return (
    <section id="signos" className="signos">
      <h2 className="display">As 12 portas do zodíaco</h2>
      <div className="sign-grid">
        {SIGNS.map((sign) => (
          <button
            key={sign.name}
            onClick={() => navigate(`/chat?sign=${encodeURIComponent(sign.name)}`)}
            className="signo"
          >
            <span className="g">{sign.glyph}</span>
            <div className="min-w-0">
              <b>{sign.name}</b>
              <span>{sign.traits}</span>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};